import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AnimatePresence, motion} from "framer-motion";

import {hideToastNotification, selectToast, ToastStatus} from "./toastNotificationSlice";

import styles from "./ToastNotification.module.css";
import classnames from "classnames";

export const ToastNotification = () => {
    const dispatch = useDispatch();
    const toasts = useSelector(selectToast);

    useEffect(() => {
        toasts.forEach((toast) => {
                if (!toast.hasTimer) {
                    setTimeout(() => {
                        dispatch(hideToastNotification(toast.id));
                    }, toast.duration)
                }
            }
        )
    }, [toasts, dispatch]);

    return (
        <div className={styles.toastContainer}>
            <AnimatePresence>
                {toasts.map(({id, message, toastStatus}) => (
                    <motion.div
                        key={id}
                        initial={{y: -40, opacity: 0}}
                        animate={{y: 0, opacity: 1}}
                        exit={{y: -40, opacity: 0}}
                        transition={{duration: 0.3}}
                        className={styles.toastWrapper}
                    >
                        <div
                            className={classnames(
                                styles.toast,
                                toastStatus === ToastStatus.SUCCESS && styles.success,
                                toastStatus === ToastStatus.ERROR && styles.error,
                                toastStatus === ToastStatus.INFO && styles.info
                            )}
                        >
                            {message}
                        </div>
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};
